<template>
  <div :id="`Player-${pid}`" class="fit rs-player"></div>
</template>

<script>
import Player from 'xgplayer/dist/core_player'
// 播放/暂停（底部控制栏左侧）
import play from 'xgplayer/dist/controls/play'
// 全屏
import fullscreen from 'xgplayer/dist/controls/fullscreen'
// 进度条
import progress from 'xgplayer/dist/controls/progress'
// 音量
import volume from 'xgplayer/dist/controls/volume'
// 画中画
import pip from 'xgplayer/dist/controls/pip'
// import miniplayer from 'xgplayer/dist/controls/miniplayer'
import flex from 'xgplayer/dist/controls/flex'
// 封面
import poster from 'xgplayer/dist/controls/poster'
// 倍速
// import playbackRate from 'xgplayer/dist/controls/playbackRate'
// 重新载入
import reload from 'xgplayer/dist/controls/reload'
// 播放时间
import time from 'xgplayer/dist/controls/time'

import HlsPlayer from 'xgplayer-hls'

export default {
  name: 'RsPlayer',
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    url: {
      type: String,
      required: true,
    },
    poster: {
      type: String,
    },
    isLive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pid: Math.random().toString().substring(2, 10),
      player: null,
    }
  },
  watch: {
    url() {
      this.init()
    },
    poster() {
      this.init()
    },
    isLive() {
      this.init()
    },
    // url() {
    //   if (this.player) {
    //     this.player.src = this.url
    //   }
    // },
  },
  methods: {
    init() {
      if (this.player) {
        this.player.destroy()
      }
      let config = {
        id: `Player-${this.pid}`,
        url: this.url,
        // pip: true,
        // videoInit: true,
        poster: this.poster,
        isLive: this.isLive,
        fitVideoSize: 'auto',
        ...this.config,
      }
      let isHLS = this.url.endsWith('.m3u8')
      if (isHLS) {
        this.player = new HlsPlayer(config)
      } else {
        config = Object.assign(config, {
          controlPlugins: [play, fullscreen, progress, volume, pip, flex, poster, reload, time],
        })
        this.player = new Player(config)
      }
    },
  },
  mounted() {
    this.init()
    window.player = this
  },
  beforeUpdate() {
    this.init()
  },
  beforeDestroy() {
    this.player && this.player.destroy()
  },
}
</script>
